module.exports = __webpack_public_path__ + "static/img/icon09.14ad7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon09.png
// module id = Pk3z
// module chunks = 0